import React from 'react';
import { useLocation } from 'react-router-dom';

import CustomerSurveyModal from './CustomerSurveyModal';
import { isSurveyExcludedRoute } from './surveyExcludedRoutes';
import { CUSTOMER_SURVEY_DISPLAY_DELAY_MS } from './surveyLoginDelay';
import useCustomerSurveyPrompt from './useCustomerSurveyPrompt';

export default function CustomerSurveyLoginPrompt() {
  const location = useLocation();

  const routeAllowed = !isSurveyExcludedRoute(location.pathname);

  const { open, config, dismiss, handleSubmit } = useCustomerSurveyPrompt({
    source: 'dashboard',
    triggerType: 'after_onboarding',
    delayMs: CUSTOMER_SURVEY_DISPLAY_DELAY_MS,
    routeAllowed,
  });

  if (!open || !config) return null;

  return <CustomerSurveyModal config={config} onDismiss={dismiss} onSubmit={handleSubmit} />;
}
